import { defineFcm } from '../shared/factory';

export const FCM_COMMS_STACK_SUBJECT_LINE_EXPERIMENTATION_ENABLED = defineFcm(
	'comms_stack_subject_line_experimentation_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig();
